import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';

@Injectable()
export class PurposeHttpService {

  constructor(private http: HttpClient) { }

  getPurposes(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/merchantbank/purpose`).pipe(
      map(res => res.data.rows)
    );
  }
}
